import * as React from 'react'
import styled from 'styled-components'

import * as entities from '@owl-nest/entities'
import * as utils from '@boutique/utils'

import * as plume from '@ulule/owl-kit-components/next'

type CriteriaProps = {
  criteria: entities.tag.MediumTag<entities.tag.ExtraPillar>[]
}

export function Criteria({ criteria }: CriteriaProps): React.ReactElement<CriteriaProps> {
  return (
    <List>
      {criteria.map((criterion) => {
        const Illustration = (plume.illustrations.boutique as any)[
          utils.symbols.getCriterionSymbolName(criterion.pillar.icon)
        ]

        return (
          <Item key={criterion.name}>
            <Illustration size={26} />
            {criterion.name}
          </Item>
        )
      })}
    </List>
  )
}

const List = styled.ul`
  display: flex;
  row-gap: 13px;
  column-gap: 16px;
  flex-direction: column;
  margin: 15px 0px 32px;
  width: 100%;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    row-gap: 16px;
    margin: 32px 0px;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    max-width: 500px;
  }
`

const Item = styled(plume.styles.heading.XXXS).attrs((props) => ({ as: 'li', ...props }))`
  display: flex;
  align-items: center;

  ${plume.illustrations.Illustration} {
    margin-right: 8px;
  }
`
